import { Card, CardHeader, CardBody, Chip, Skeleton, Tooltip } from "@heroui/react";
import { ThemedText } from "@/components/ui";
import { formatCurrency, formatDate } from "@/utils";
import { LuInfo } from "react-icons/lu";

const SkeletonRow = () => (
    <div className="flex items-center justify-between py-3">
        <div className="flex flex-col gap-1.5">
            <Skeleton className="h-4 w-32 rounded-md" />
            <Skeleton className="h-3 w-24 rounded-md" />
        </div>
        <div className="flex flex-col items-end gap-1.5">
            <Skeleton className="h-4 w-24 rounded-md" />
            <Skeleton className="h-5 w-16 rounded-full" />
        </div>
    </div>
);

const RecentOrdersCard = ({ orders, isLoading }) => {
    return (
        <Card className="border-default-200 border" shadow="none">
            <CardHeader className="flex flex-row items-center gap-1.5 px-4 pt-4 pb-0">
                <Tooltip
                    content="7 pesanan penjualan & pembelian terbaru berdasarkan tanggal"
                    placement="right"
                >
                    <span className="cursor-help text-default-400">
                        <LuInfo size={12} />
                    </span>
                </Tooltip>
                <ThemedText size="md" className="font-semibold">
                    Pesanan Terbaru
                </ThemedText>
            </CardHeader>
            <CardBody className="px-4 pt-2 pb-4">
                <div className="divide-default-100 divide-y">
                    {isLoading ? (
                        Array.from({ length: 7 }).map((_, i) => (
                            <SkeletonRow key={i} />
                        ))
                    ) : orders?.length > 0 ? (
                        orders.map((order) => (
                            <div
                                key={`${order.type}-${order.id}`}
                                className="flex items-center justify-between py-3"
                            >
                                <div className="flex flex-col gap-0.5">
                                    <div className="flex items-center gap-1.5">
                                        <ThemedText
                                            size="sm"
                                            className="font-medium"
                                        >
                                            {order.order_number}
                                        </ThemedText>
                                        <ThemedText
                                            variant="secondary"
                                            size="xs"
                                        >
                                            ({formatDate(order.order_date)})
                                        </ThemedText>
                                    </div>
                                    <ThemedText variant="secondary" size="xs">
                                        {order.party_name} &middot;{" "}
                                        {order.type_label}
                                    </ThemedText>
                                </div>
                                <div className="flex flex-col items-end gap-1">
                                    <ThemedText
                                        size="sm"
                                        className="font-medium"
                                    >
                                        {formatCurrency(order.total_amount)}
                                    </ThemedText>
                                    <Chip
                                        color={
                                            order.status_color || "default"
                                        }
                                        size="sm"
                                        variant="flat"
                                    >
                                        {order.status_name}
                                    </Chip>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="py-8 text-center">
                            <ThemedText variant="secondary" size="sm">
                                Belum ada pesanan.
                            </ThemedText>
                        </div>
                    )}
                </div>
            </CardBody>
        </Card>
    );
};

export default RecentOrdersCard;
